import './App.css';
import React, {   useState ,useContext,useEffect} from "react";
import { Routes, Route,Navigate } from 'react-router-dom';
import Categories from './Components/Categories/Categories';
import DataSet from './Components/DataSet/DataSet';
import MainPage from './Pages/MainPage';
import FilterPage from './Pages/FilterPage';
import DataItemPage from './Pages/DataItemPage';
import { createContext } from 'react';
import {LanguageContext} from './context'
import { Helmet } from 'react-helmet';


import {createTheme, ThemeProvider} from '@mui/material/styles';
import rtlPlugin from 'stylis-plugin-rtl';
import {prefixer} from 'stylis';
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import VisibilityIcon from '@mui/icons-material/Visibility';

import AboutPage from './Pages/AboutPage';
import TermsOfUsePage from './Pages/TermsOfUsePage';

import DeveloperPage from './Pages/DeveloperPage';
import AccessibilityPage from './Pages/AccessibilityPage';
import Page404 from './Pages/Page404';
import Translate, { useTranslate } from './Components/Translate/Translate';


const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

const cacheLft = createCache({
  key: 'muirltr',
  stylisPlugins: [],
});



function App() {
  
  const { language } = useContext(LanguageContext);
  const skipLinkTitle = useTranslate("GoToContent");
 // let dir=language="he"? 'rtl':'ltr'
  const themeLeft = createTheme({
    
    direction:'ltr',
  });
  const themeRight = createTheme({
    
    direction:'rtl',
  });


  useEffect(() => {
    var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;           
    if (window.location.href.indexOf('opendata.tel-aviv.gov.il') > 0) {
        ga.setAttribute('data-clsconfig', 'reportURI= https://report.c3001.gbqofs.io/yl87mo4g/reporting/6f2bda68-cacf-2cb2-988b-f20195413100/cls_report;');
        ga.src = 'https://cdn.gbqofs.com/tlvm/p/detector-dom.min.js';                
    }
    else {
        ga.setAttribute('data-clsconfig', 'reportURI= https://report.c3001.gbqofs.io/yl87mo4g/reporting/1f7a235f-15b8-7510-7fef-c028be6d7088/cls_report;');
        ga.src = 'https://cdn.gbqofs.com/tlvm/u/detector-dom.min.js';
    }
                   
    var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ga, s);

  }, []);

  return (

    <div className="App">
    <Helmet>
      <title>App Title</title>
      <meta name="description" content="App Description" />
     
    </Helmet>
  
      <CacheProvider value={language=="he"?cacheRtl:cacheLft}>
      <ThemeProvider theme={language=="he"?themeRight:themeLeft}>

   
    <div className='open-data-main' lang={language}>

      <a className="skip-link" title={skipLinkTitle} href="#main-content-title">
        <VisibilityIcon className="skip-link-icon" aria-hidden="true" focusable="false" />
        <span><Translate>GoToContent</Translate></span>
      </a>


      <Routes>
       

       
      <Route path='/' element={<MainPage/>}/>
      <Route path='/:langParam' element={<MainPage/>}/>
        <Route path='/data/:categoryFilter' element={<MainPage/>}/>
        <Route path='/filter/:categoryFilter/:typeSearch' element={<MainPage/>}/>
        <Route path='/search/:freeText' element={<MainPage/>}/>
        <Route path='/:langParam/dataItem/:id/:selectedTab' element={<DataItemPage   />}/>

        <Route path='/:langParam/Pages/item.aspx' element={<DataItemPage   />}/>
        
        <Route path='/:langParam/dataItem/:id' element={<DataItemPage   />}/>
        <Route path='/:langParam/about' element={<AboutPage />}/>  
        <Route path='/:langParam/terms' element={<TermsOfUsePage />}/>  
        <Route path='/:langParam/developer' element={<DeveloperPage/>}/>
        <Route path='/:langParam/accessibility' element={<AccessibilityPage />}/>
        
        <Route path='/404page'  element={<Page404/>}/>
        <Route path='*'  element={<Navigate to='/404page'/>}/>
      


      </Routes>
   
    </div>

       </ThemeProvider>
          </CacheProvider>
 
          </div>

   
  );
}

export default App;

